const logos = {
  chubb:                  require("./chubb.png"),
  // Forcefield wordmarks: reversed (white) for dark backgrounds, black for
  // light backgrounds, orange for the rebrand webform header.
  forcefieldLogoBigWhite: require("./forcefield-logo-reversed.svg").default,
  forcefieldLogoBlack:    require("./forcefield-logo-black.svg").default,
  forcefieldLogoOrange:   require("./forcefield-logo-orange.svg").default,
  logo:                   require("./logo.svg").default,
  logoBig:                require("./logo-big.svg").default,
  logoBigPng:             require("./logo-big.png"),
  logoBigWhite:           require("./logo-big-white.svg").default,
  logoPng:                require("./logo.png"),
  noImage:                require("./no-image.png"),
  poweredBy:              require("./poweredby.png")
}

export default logos
